export const formatFilterValues = filters => {
    return filters
        .map(filter => {
            const field = filter.field.display_name || filter.field.name;
            const tags = filter.tags.map(tag => tag.display_name || tag.name);
            return `${field}(${tags.join(', ')})`;
        })
        .join(', ');
};
